import { FaChair, FaBolt, FaShieldAlt, FaMobileAlt } from "react-icons/fa";

/* ---------------- Theme ---------------- */
const PALETTE = {
  primaryRed: "#D84E55",
  accentBlue: "#3A86FF",
  textDark: "#1A1A1A",
  textLight: "#4B5563",
  bgLight: "#FFFFFF",
  borderLight: "#E0E0E0",
  white: "#FFFFFF",
};

const SECTION_WRAP = "full-bleed";
const SECTION_INNER =
  "w-full max-w-[1400px] 2xl:max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8";

/* ---------------- Popular Cities for quick-pick ---------------- */
const POPULAR_CITIES = [
  "Colombo",
  "Kandy",
  "Galle",
  "Matara",
  "Jaffna",
  "Negombo",
  "Kurunegala",
  "Gampaha",
  "Badulla",
  "Anuradhapura",
];

/* ---------------- Data (unchanged) ---------------- */
const whyChooseUsData = [
  {
    icon: FaChair,
    title: "Choose Your Seat",
    desc: "See live availability and pick the seat you prefer before you confirm.",
  },
  {
    icon: FaBolt,
    title: "Fast, Simple Booking",
    desc: "Search routes, compare options, and book in minutes — no long calls or queues.",
  },
  {
    icon: FaShieldAlt,
    title: "Secure Payments & Instant Ticket",
    desc: "Pay safely and get instant confirmation with a digital ticket ready on your phone.",
  },
  {
    icon: FaMobileAlt,
    title: "Made for Everyday Travel",
    desc: "A smooth, passenger-friendly experience designed for Sri Lankan intercity journeys.",
  },
];

const IOS_BAR_COLOR = "#ffffff"; // change if you want the status area to be another color

export { PALETTE, SECTION_WRAP, SECTION_INNER, POPULAR_CITIES, whyChooseUsData, IOS_BAR_COLOR };
